import { skipToken } from "@reduxjs/toolkit/query";
import { createContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useGetMessagesQuery } from "src/api/services/messagesApi";
import { MessageType } from "src/api/types";
import { MatchParam } from "src/constants/matches";

export const MessagingContext = createContext<MessageType[]>([]);

interface Props {
  children: React.ReactNode;
}

const MessagingProvider = ({ children }: Props) => {
  const { thread } = useParams<MatchParam<"THREAD_ID">>();
  const { data } = useGetMessagesQuery(thread ?? skipToken);

  const messages = useMemo(() => {
    if (data == null) return [];
    return data;
  }, [data]);

  return (
    <MessagingContext.Provider value={messages}>
      {children}
    </MessagingContext.Provider>
  );
};

export default MessagingProvider;
